import { AdhaUaePassErrorCode, AdhaUaePassErrorDescription } from '@/modules/auth/constants/adhaUaePassError';
import { Redirect, useLocalSearchParams } from 'expo-router';
import React from 'react';

/**
 * Native UAE Pass authenticator failure return: `{scheme}://uaePassFail`.
 * Forwards into the ADHA `/uae-pass` handler as a cancelled/error callback.
 */
export default function UaePassFailRoute() {
  const params = useLocalSearchParams();
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    const raw = Array.isArray(value) ? value[0] : value;
    if (typeof raw === 'string' && raw.length > 0) {
      query.set(key, raw);
    }
  });
  if (!query.get('error')) {
    query.set('error', AdhaUaePassErrorCode.CANCELLED_ON_APP);
  }
  if (!query.get('error_description')) {
    query.set('error_description', AdhaUaePassErrorDescription.APP);
  }
  return <Redirect href={`/uae-pass?${query.toString()}`} />;
}
